/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import store from '../../../store/store'

export default [
	{
		url: '/dashboard',
		name: 'Dashboard',
		icon: ['fas', 'tachometer-alt']
	},
	{
		url: '/orders',
		name: 'Bestellingen',
		tag: () => {
			return store.getters['openOrdersStore/amount'];
		},
		tagColor: 'primary',
		icon: ['fas', 'boxes']
	},
	{
		url: '/orders/dropship',
		name: 'Dropship',
		icon: ['fas', 'people-carry']
	},
	{
		url: '/orders/voltooid',
		name: 'Voltooid',
		icon: ['fas', 'check-double']
	},

	{
		url: null,
		name: 'Producten',
		slug: 'products',
		icon: ['fas', 'store'],
		submenu: [
			{
				url: '/products',
				name: 'Alle producten',
				slug: 'allProducts',
				icon: ['fas', 'list']
			},
			{
				url: '/products/pools',
				name: 'Voorraad pools',
				slug: 'productsPools',
				icon: ['fas', 'cubes'],
				hide: () => {
					return !store.getters['dashboard/moduleStockPoolsEnabled'];
				}
			}
		]
	},
	{
		url: '/packages',
		name: 'Verpakkingen',
		icon: ['fas', 'box-open']
	},
	{
		url: null,
		name: 'Instellingen',
		slug: 'settings',
		icon: ['fas', 'cogs'],
		submenu: [
			{
				url: '/modules/overzicht',
				name: 'Modules',
				slug: 'modules',
				icon: ['fas', 'cubes']
			},
			{
				url: '/instellingen/notificaties',
				name: 'Notificaties',
				slug: 'NotificationsSettings',
				icon: ['fas', 'comment']
			},
			{
				url: '/instellingen/verzending',
				name: 'Verzendopties',
				slug: 'verzendopties',
				icon: ['fas', 'shipping-fast']
			},
			{
				url: '/instellingen/levertijd',
				name: 'Levertijd aanpassen',
				slug: 'Levertijd',
				icon: ['fas', 'stopwatch']
			},
			{
				url: '/instellingen/abonnement',
				name: 'Abonnement',
				slug: 'Subscriptions',
				icon: ['fas', 'book-open']
			}
		]
	},
	{
		url: '/Support',
		name: 'Ondersteuning',
		slug: 'support',
		icon: ['fas', 'headset']
	},
]
